<template>
  <div class="filter-modal-overlay" @click.self="closeModal">
    <div class="filter-modal" @click.stop>
      <div class="filter-content">
        <!-- 考试类型 -->
        <div class="filter-section">
          <h3 class="section-title">考试类型</h3>
          <div class="tag-group">
            <button
              v-for="item in examTypeOptions"
              :key="'exam-' + item.key"
              type="button"
              class="tag-item"
              :class="{ active: isExamActive(item.idList) }"
              @click="toggleExam(item.idList)"
            >
              {{ item.label }}
            </button>
          </div>
        </div>

        <!-- 科目（仅选四六级、未选其他考试类型时不展示） -->
        <div v-show="showSubjectAndBook" class="filter-section">
          <h3 class="section-title">科目</h3>
          <div class="tag-group">
            <button
              v-for="item in subjectOptions"
              :key="'sub-' + item.key"
              type="button"
              class="tag-item"
              :class="{ active: isSubjectActive(item.idList) }"
              @click="toggleSubject(item.idList)"
            >
              {{ item.label }}
            </button>
          </div>
        </div>

        <!-- 图书分类（仅选四六级、未选其他考试类型时不展示） -->
        <div v-show="showSubjectAndBook" class="filter-section">
          <h3 class="section-title">图书分类</h3>
          <div class="tag-group">
            <button
              v-for="item in bookTypeOptions"
              :key="'book-' + item.key"
              type="button"
              class="tag-item"
              :class="{ active: isBookTypeActive(item.idList) }"
              @click="toggleBookType(item.idList)"
            >
              {{ item.label }}
            </button>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="btn-group">
          <button type="button" class="btn-reset" @click="handleReset">重置</button>
          <button type="button" class="btn-confirm" @click="handleConfirm">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CET_EXAM_TYPE_ID } from '../constants/bookMallFilterOptions';
import { reqTypeList } from '@/api/home';

export default {
  name: 'FilterModal',
  props: {
    initialFilter: {
      type: Object,
      default: () => ({
        examTypeIdList: [],
        subjectIdList: [],
        bookTypeIdList: [],
      }),
    },
  },
  data() {
    return {
      CET_EXAM_TYPE_ID,
      examTypeOptions: [],
      subjectOptions: [],
      bookTypeOptions: [],
      examTypeIdList: [],
      subjectIdList: [],
      bookTypeIdList: [],
    };
  },
  computed: {
    showSubjectAndBook() {
      const list = this.examTypeIdList;
      if (!list.length) return true;
      const onlyCet = list.every((id) => CET_EXAM_TYPE_ID.includes(id));
      return !onlyCet;
    },
  },
  watch: {
    initialFilter: {
      deep: true,
      immediate: true,
      handler() {
        this.syncFromInitial();
      },
    },
  },
  methods: {
    parseRemarkOptions(row) {
      if (!row?.remark) return [];
      try {
        const list = JSON.parse(row.remark);
        if (!Array.isArray(list)) return [];
        return list
          .map((x) => {
            const rawIdList = Array.isArray(x.id) ? x.id : [x.id];
            const idList = rawIdList.map(Number).filter((id) => !Number.isNaN(id));
            if (!idList.length) return null;
            return {
              key: idList.join('_'),
              idList,
              label: x.label,
            };
          })
          .filter(Boolean);
      } catch {
        return [];
      }
    },
    isActiveByIdList(selectedList, idList) {
      return idList.every((id) => selectedList.includes(id));
    },
    toggleIdGroup(selectedList, idList) {
      const list = [...selectedList];
      const isActive = this.isActiveByIdList(list, idList);
      if (isActive) {
        return list.filter((id) => !idList.includes(id));
      }
      return [...new Set([...list, ...idList])];
    },
    pickOptionsByCode(list, code) {
      const row = (list || []).find((item) => item.code === code);
      return row ? this.parseRemarkOptions(row) : [];
    },
    async getTypeList() {
      const res = await reqTypeList('BOOK_MALL_SUBJECT');
      if (res.code !== 0 || !Array.isArray(res.data)) return;
      this.examTypeOptions = this.pickOptionsByCode(res.data, 'year');
      this.subjectOptions = this.pickOptionsByCode(res.data, 'subject');
      this.bookTypeOptions = this.pickOptionsByCode(res.data, 'book_type');
    },
    syncFromInitial() {
      const v = this.initialFilter || {};
      this.examTypeIdList = [...(v.examTypeIdList || [])];
      this.subjectIdList = [...(v.subjectIdList || [])];
      this.bookTypeIdList = [...(v.bookTypeIdList || [])];
    },
    isExamActive(idList) {
      return this.isActiveByIdList(this.examTypeIdList, idList);
    },
    isSubjectActive(idList) {
      return this.isActiveByIdList(this.subjectIdList, idList);
    },
    isBookTypeActive(idList) {
      return this.isActiveByIdList(this.bookTypeIdList, idList);
    },
    toggleExam(idList) {
      this.examTypeIdList = this.toggleIdGroup(this.examTypeIdList, idList);
      if (
        this.examTypeIdList.length &&
        this.examTypeIdList.every((id) => CET_EXAM_TYPE_ID.includes(id))
      ) {
        this.subjectIdList = [];
        this.bookTypeIdList = [];
      }
    },
    toggleSubject(idList) {
      if (!this.showSubjectAndBook) return;
      this.subjectIdList = this.toggleIdGroup(this.subjectIdList, idList);
    },
    toggleBookType(idList) {
      if (!this.showSubjectAndBook) return;
      this.bookTypeIdList = this.toggleIdGroup(this.bookTypeIdList, idList);
    },
    handleReset() {
      this.examTypeIdList = [];
      this.subjectIdList = [];
      this.bookTypeIdList = [];
    },
    buildPayload() {
      const examTypeIdList = [...this.examTypeIdList];
      const subjectIdList = this.showSubjectAndBook ? [...this.subjectIdList] : [];
      const bookTypeIdList = this.showSubjectAndBook ? [...this.bookTypeIdList] : [];
      return { examTypeIdList, subjectIdList, bookTypeIdList };
    },
    handleConfirm() {
      this.$emit('confirm', this.buildPayload());
    },
    closeModal() {
      this.$emit('close');
    },
  },
  mounted() {
    this.getTypeList();
  },
};
</script>

<style lang="scss" scoped>
// 遮罩层
.filter-modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: flex-end; // 内容靠底部
  background-color: rgba(0, 0, 0, 0.5);
}

// 弹窗容器
.filter-modal {
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
}

// 内容区
.filter-content {
  height: 888px;
  padding: 46px 36px;
  background: #fff;
  border-radius: 36px 36px 0 0;
  box-shadow: 0 -4 18px 0 rgba(0, 0, 0, 0.07);
}

// 区块样式
.filter-section {
  margin-bottom: 58px;

  .section-title {
    position: relative;
    margin-bottom: 29px;
    padding-left: 18px;
    color: #333;
    font-weight: 500;
    font-size: 29px;

    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      width: 7px;
      height: 29px;
      background: linear-gradient(180deg, #ffd24e 0%, #ff9902 100%);
      border-radius: 4px;
      transform: translateY(-50%);
      content: '';
    }
  }

  .tag-group {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;

    .tag-item {
      width: 152px;
      height: 69px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 69px;
      background: #f5f7fb;
      border-radius: 34px;
      transition: all 0.2s;

      &.active {
        color: #fff;
        background: #ff7f41;
      }

      &:not(.active) {
        color: #333;
        background: #f5f7fb;
      }
    }
  }
}

// 按钮组
.btn-group {
  display: flex;
  gap: 18px;
  margin-top: 8px;

  .btn-reset {
    flex: 1;
    height: 80px;
    color: #ff7f41;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #fff;
    border: 2px solid #ff7f41;
    border-radius: 49px;
  }

  .btn-confirm {
    flex: 1;
    height: 80px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 49px;
  }
}
</style>
